// LoginPage.jsx
import { useLocation } from 'react-router';
import { useAuth0 } from '@auth0/auth0-react';
import Spinner from '@/components/spinner/Spinner';
import { useEffect } from 'react';

function LoginPage() {
	const { loginWithRedirect } = useAuth0();
	const location = useLocation();

	const searchParams = new URLSearchParams(location.search);
	const returnTo = searchParams.get('returnTo') || location.state?.from?.pathname || '/';

	const handleLogin = () => {
		loginWithRedirect({
			appState: { returnTo }
		});
	};

	useEffect(() => {
		handleLogin();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="flex flex-col items-center justify-center h-full">
			<Spinner size={64} />
		</div>
	);
}

export default LoginPage;
